// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".62a180f4548cddf24ae3a451b3d705466a1e52b3.chunk.bundle.js";
};